<template lang="pug">
.home
  FlightSpeedCanvas
</template>

<script>
import FlightSpeedCanvas from '@/components/flight-speed-canvas'
export default {
  name: 'Home'
  , components: {
    FlightSpeedCanvas
  }
}
</script>

<style lang="sass" scoped>

</style>
